import React from 'react';
import {
    Row,
    Col,
    Figure,
    Popover,
    OverlayTrigger,
    Button,
    FormControl,
    Form,
    Card,
    Image,
    Modal,
    InputGroup,
} from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../Styles.css';
import Path from '../../Components/Path/Path';
import t from '../../Components/Translations/lang.json';
import PC from '../../Components/PostalCodes/PostalCodes.json';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Questionaire from '../../Components/Questionaire/Questionaire';
import TeamImg from '../../Assets/teamImg.png';
import BuildingIcon from '../../Assets/buildingIcon.png';
import RepairIcon from '../../Assets/repairIcon.png';
import ExpandIcon from '../../Assets/expandIcon.png';
import RetroFitIcon from '../../Assets/plusIcon.png';
import OptimizationIcon from '../../Assets/optIcon.png';
import InfoIcon from '../../Assets/infoIcon.png';
import ArrowRight from '../../Assets/arrowRight.png';
import axios from 'axios';
import Postal from './Postal';
import { Bullseye } from 'react-bootstrap-icons';

const Home = () => {
    var url = new URL(window.location);
    var lang = url.searchParams.get('language')
        ? url.searchParams.get('language')
        : 'de';
    const currentLang = lang;
    const [selectedService, setSelectedService] = React.useState('');
    const [isNewCustomer, setNewCustomer] = React.useState(false);
    const [query, setQuery] = React.useState('');
    const [selectDuration, setSelectDuration] = React.useState('timeley');
    const [selectDate, setSelectedDate] = React.useState('');
    const [question, setQuestion] = React.useState(t[currentLang].welcome);
    const [tipTxt, setTipTxt] = React.useState(t[currentLang].tip0);
    const [postalAddress, setPostalAddress] = React.useState('');
    const [postalCode, setPostalCode] = React.useState('');
    const [requestTitle, setRequestTitle] = React.useState('');
    const [emailAddress, setEmailAddress] = React.useState('');
    const [fullName, setFullName] = React.useState('');

    const [country, setCountry] = React.useState('us');
    const [cities, setCities] = React.useState(PC.cities.us);
    // to set requestid to use in resend option
    const [requestId, setRequestId] = React.useState(0);
    const [requestKey, setRequestKey] = React.useState('');

    const [recaptcha, showRecaptcha] = React.useState(false);

    // controle modal
    const [modalShow, setModalShow] = React.useState(false);

    const timelyRadio = [
        { name: t[currentLang].timely, value: 'timeley' },
        { name: t[currentLang].thirtyDays, value: '30days' },
        { name: t[currentLang].threeMonth, value: '3months' },
        { name: t[currentLang].threeSixMonth, value: '3or6months' },
        { name: t[currentLang].morethan6, value: 'morethan6' },
        { name: t[currentLang].datePicker, value: 'datePicker' },
    ];

    const [showStepZero, setShowStepZero] = React.useState(true);
    const [showStepOne, setShowStepOne] = React.useState(false);
    const [showStepTwo, setShowStepTwo] = React.useState(false);
    const [showStepThree, setShowStepThree] = React.useState(false);
    const [showStepFour, setShowStepFour] = React.useState(false);
    const [showStepFive, setShowStepFive] = React.useState(false);
    const [showStepSix, setShowStepSix] = React.useState(false);
    const [showStepSeven, setShowStepSeven] = React.useState(false);

    const [isValidEmail, setIsValidEmail] = React.useState(false);
    const [isConfirmEmail, setIsConfirmEmail] = React.useState(false);
    const [checkTerms, setCheckTerms] = React.useState(false);
    const [infoText, setInfoText] = React.useState(t[currentLang].q1info);
    const [placeholderTxt, setPlaceholderTxt] = React.useState(
        t[currentLang].q2Placeholder
    );

    const onReCaptchaChange = (value) => {
        console.log('Captcha value:', value);
    };

    const popoverNewBuilding = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].nBuildingPopOver}</Popover.Content>
        </Popover>
    );

    const popoverRetroFit = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].retPopOver}</Popover.Content>
        </Popover>
    );

    const popoverExpand = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].expandPopOver}</Popover.Content>
        </Popover>
    );

    const popoverOptimization = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].optPopOver}</Popover.Content>
        </Popover>
    );

    const popoverRepair = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].repairPopOver}</Popover.Content>
        </Popover>
    );

    const popoverError = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].dataWarning}</Popover.Content>
        </Popover>
    );

    const popoverInValidEmail = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].emailWarning}</Popover.Content>
        </Popover>
    );

    const popoverNotConfirmEmail = (
        <Popover id='popover'>
            <Popover.Content>
                {t[currentLang].confirmEmailWarning}
            </Popover.Content>
        </Popover>
    );

    const popoverFullNameErr = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].fullNameWarning}</Popover.Content>
        </Popover>
    );

    const popoverAcceptTerms = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].acceptTrmWarning}</Popover.Content>
        </Popover>
    );

    const popoverDateError = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].dateWarning}</Popover.Content>
        </Popover>
    );
    const popoverPostalCodeInfo = (
        <Popover id='popover'>
            <Popover.Content>
                {t[currentLang].executionOrderinfo}
            </Popover.Content>
        </Popover>
    );
    const popoverTitleinfo = (
        <Popover id='popover'>
            <Popover.Content>{t[currentLang].orderTitleinfo}</Popover.Content>
        </Popover>
    );

    const handleSubmit = async () => {
        const data = {
            service: selectedService,
            title: requestTitle,
            description: query,
            postal_address: postalAddress,
	    postal_code: postalCode,
            email: emailAddress,
            full_name: fullName,
            deadline:
                selectDuration === 'datePicker' ? selectDate : selectDuration,
            language: currentLang,
        };

        await axios({
            url: Path.baseUrl,
            method: 'POST',
            data: JSON.stringify(data),
        }).then((response) => {
	    console.log(response);
            setRequestId(response.data.data.request_id);
            setRequestKey(response.data.data.request_key);
            // const [requestKey,] = React.useState('');

            console.log(response.data.data.request_id);
        });
    };

    const handleReSend = async () => {
        const data = {
            email: emailAddress,
            user_name: fullName,
            req_id: requestId,
            req_key: requestKey,
            language: currentLang,
        };

        await axios({
            url: Path.basePath + '/resend_email.php',
            method: 'POST',
            data: JSON.stringify(data),
        }).then((response) => console.log(response));
    };

    const handleQuery = (event) => {
        setQuery(event.target.value);
    };

    const handleCountry = (event) => {
        let country = event.target.value;
        setCountry(country);
        setCities(PC.cities[country]);
        let cty = PC.cities[country][0];
        setPostalCode(PC.codes[country][cty]);
    };

    const handleCity = (event) => {
        const city = event.target.value;
        setPostalCode(PC.codes[country][city]);
    };

    const handleEmailAddress = (event) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(event.target.value).toLowerCase())) {
            setEmailAddress(event.target.value);
            setIsValidEmail(true);
        }
    };

    const handleConfirmEmail = (event) => {
        if (emailAddress === event.target.value) {
            setIsConfirmEmail(true);
        }
    };

    const handleNext = (step, selected) => {
        if (step === 0) {
            setQuestion(t[currentLang].welcome);
            setShowStepZero(true);
            // setShowStepOne(false);
            setTipTxt(t[currentLang].tip0);
            // setInfoText(t[currentLang].q1info);
        }
        if (step === 1) {
            setQuestion(t[currentLang].q1);
            setShowStepZero(false);
            setShowStepOne(true);
            // setShowStepTwo(false);
            setInfoText(t[currentLang].q1info);
            setTipTxt(t[currentLang].tip1);
        }
        if (step === 2) {
            if (selected === 'newbuilding') {
                // alert('selectedService', selectedService);
                setPlaceholderTxt(t[currentLang].q2Placeholder);
                setQuestion(t[currentLang].q2);
                setInfoText(t[currentLang].q2info);
                setTipTxt(t[currentLang].tip2);
            }
            if (selected === 'retrofit') {
                setPlaceholderTxt(t[currentLang].q3Placeholder);
                setQuestion(t[currentLang].q3);
                setInfoText(t[currentLang].q3info);
                setTipTxt(t[currentLang].tip3);
            }

            if (selected === 'expand') {
                setPlaceholderTxt(t[currentLang].q4Placeholder);
                setQuestion(t[currentLang].q4);
                setInfoText(t[currentLang].q4info);
                setTipTxt(t[currentLang].tip4);
            }

            if (selected === 'optimization') {
                setPlaceholderTxt(t[currentLang].q5Placeholder);
                setQuestion(t[currentLang].q5);
                setInfoText(t[currentLang].q5info);
                setTipTxt(t[currentLang].tip5);
            }

            if (selected === 'repair') {
                setPlaceholderTxt(t[currentLang].q6Placeholder);
                setQuestion(t[currentLang].q6);
                setInfoText(t[currentLang].q6info);
                setTipTxt(t[currentLang].tip6);
            }

            setShowStepOne(false);
            setShowStepTwo(true);
        }
        if (step === 3) {
            setQuestion(t[currentLang].executionOrder);
            setInfoText(t[currentLang].executionOrderinfo);

            setShowStepTwo(false);
            setShowStepThree(true);
            setTipTxt(t[currentLang].postalCodeTip);
        }
        if (step === 4) {
            setQuestion(t[currentLang].executionTime);
            setInfoText(t[currentLang].executionTimeinfo);

            setShowStepThree(false);
            setShowStepFour(true);
        }
        if (step === 5) {
            setQuestion(t[currentLang].orderTitle);
            setInfoText(t[currentLang].orderTitleinfo);

            setShowStepFour(false);
            setShowStepFive(true);
            setTipTxt(t[currentLang].smartHomeTip);
        }
        if (step === 6) {
            setQuestion(t[currentLang].almostReady);

            setShowStepFive(false);
            setShowStepSix(true);
        }
        if (step === 7) {
            handleSubmit();
            setQuestion(t[currentLang].ready);

            setShowStepSix(false);
            setShowStepSeven(true);
        }
    };

    const handleSelection = (selection) => {
        setSelectedService(selection);
        // alert('selection' + selection + selectedService);
        handleNext(2, selection);
    };

    return (
        <>
            <Header question={question} />
            <CSSTransition
                in={showStepZero}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepOne(false)}
                // onExited={() => setShowStepZero(false)}
            >
                <>
                    <Row
                        className={
                            'p-4 justify-content-center main-container-form'
                        }
                    >
                        <Col xs={12} lg={5}>
                            <Image
                                src={TeamImg}
                                thumbnail
                                style={{ width: '100%' }}
                            />
                        </Col>
                        <Col xs={12} lg={7}>
                            {/*<p style={{ textAlign: 'justify' }}>*/}
			    <p>
                                {t[currentLang].welcomeTxt1}
                            </p>
                            {/*<p style={{ textAlign: 'justify' }}>*/}
			    <p>
                                {t[currentLang].welcomeTxt2}
                            </p>
                            <Row>
                                <Col xs={6} sm={6} lg={6}>
                                    <Button
                                        className='btn-nxt  mt-5'
                                        onClick={() => {
                                            setNewCustomer(false);
                                            handleNext(1);
                                        }}
                                    >
                                        {t[currentLang].existingUser}
                                    </Button>
                                </Col>
                                {/* <Col xs={4} sm={4} lg={3}></Col> */}
                                <Col xs={6} sm={6} lg={6}>
                                    <Button
                                        className='btn-nxt  mt-5'
                                        onClick={() => {
                                            setNewCustomer(true);
                                            handleNext(1);
                                        }}
                                    >
                                        {t[currentLang].newUser}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* <Row className={'justify-content-end  m-0  mb-5'}>
                        <Col xs={4} sm={4} lg={1}></Col>
                        <Col xs={4} sm={4} lg={3}>
                            <Button
                                className='btn-nxt  mt-5'
                                onClick={() => {
                                    setNewCustomer(false);
                                    handleNext(1);
                                }}
                            >
                                {t[currentLang].existingUser}
                            </Button>
                        </Col>
                        <Col xs={4} sm={4} lg={5}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt  mt-5'
                                onClick={() => {
                                    setNewCustomer(true);
                                    handleNext(1);
                                }}
                            >
                                {t[currentLang].newUser}
                            </Button>
                        </Col>

                        <Col xs={4} sm={4} lg={1}></Col>
                    </Row>
                 */}
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepOne}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepTwo(false)}
                // onExited={() => setShowStepOne(false)}
            >
                <>
                    <Row
                        className={'p-4 justify-content-center main-container'}
                    >
                        {isNewCustomer ? (
                            <>
                                <Col
                                    sm={4}
                                    lg={2}
                                    className={
                                        selectedService == 'newbuilding'
                                            ? 'bx-container bg-selected'
                                            : 'bx-container'
                                    }
                                    onClick={() => {
                                        handleSelection('newbuilding');
                                    }}
                                >
                                    <OverlayTrigger
                                        trigger='hover'
                                        trigger='focus'
                                        placement='top'
                                        overlay={popoverNewBuilding}
                                    >
                                        <Figure>
                                            <Figure.Image
                                                width={171}
                                                height={180}
                                                alt='171x180'
                                                src={BuildingIcon}
                                            />
                                            <Figure.Caption className='text-center caption-txt'>
                                                {t[currentLang].newBuilding}
                                            </Figure.Caption>
                                        </Figure>
                                    </OverlayTrigger>
                                </Col>
                                <Col
                                    sm={4}
                                    lg={2}
                                    className={
                                        selectedService === 'retrofit'
                                            ? 'bx-container bg-selected'
                                            : 'bx-container'
                                    }
                                    onClick={() => {
                                        handleSelection('retrofit');
                                        // handleNext(2);
                                    }}
                                >
                                    <OverlayTrigger
                                        trigger='hover'
                                        trigger='focus'
                                        placement='top'
                                        overlay={popoverRetroFit}
                                    >
                                        <Figure>
                                            <Figure.Image
                                                width={171}
                                                height={180}
                                                alt='171x180'
                                                src={ExpandIcon}
                                            />
                                            <Figure.Caption className='text-center caption-txt'>
                                                {t[currentLang].retrofit}
                                            </Figure.Caption>
                                        </Figure>
                                    </OverlayTrigger>
                                </Col>
                            </>
                        ) : (
                            <>
                                <Col
                                    sm={4}
                                    lg={2}
                                    className={
                                        selectedService === 'expand'
                                            ? 'bx-container bg-selected'
                                            : 'bx-container'
                                    }
                                    onClick={() => {
                                        handleSelection('expand');
                                        // handleNext(2);
                                    }}
                                >
                                    <OverlayTrigger
                                        trigger='hover'
                                        trigger='focus'
                                        placement='top'
                                        overlay={popoverExpand}
                                    >
                                        <Figure>
                                            <Figure.Image
                                                width={171}
                                                height={180}
                                                alt='171x180'
                                                src={RetroFitIcon}
                                            />
                                            <Figure.Caption className='text-center caption-txt'>
                                                {t[currentLang].expand}
                                            </Figure.Caption>
                                        </Figure>
                                    </OverlayTrigger>
                                </Col>
                                <Col
                                    sm={4}
                                    lg={2}
                                    className={
                                        selectedService === 'optimization'
                                            ? 'bx-container bg-selected'
                                            : 'bx-container'
                                    }
                                    onClick={() => {
                                        handleSelection('optimization');
                                        // handleNext(2);
                                    }}
                                >
                                    <OverlayTrigger
                                        trigger='hover'
                                        trigger='focus'
                                        placement='top'
                                        overlay={popoverOptimization}
                                    >
                                        <Figure>
                                            <Figure.Image
                                                width={171}
                                                height={180}
                                                alt='171x180'
                                                src={OptimizationIcon}
                                            />
                                            <Figure.Caption className='text-center caption-txt'>
                                                {t[currentLang].optimization}
                                            </Figure.Caption>
                                        </Figure>
                                    </OverlayTrigger>
                                </Col>
                                <Col
                                    sm={4}
                                    lg={2}
                                    className={
                                        selectedService === 'repair'
                                            ? 'bx-container bg-selected'
                                            : 'bx-container'
                                    }
                                    onClick={() => {
                                        handleSelection('repair');
                                        // handleNext(2);
                                    }}
                                >
                                    <OverlayTrigger
                                        trigger='hover'
                                        trigger='focus'
                                        placement='top'
                                        overlay={popoverRepair}
                                    >
                                        <Figure>
                                            <Figure.Image
                                                width={171}
                                                height={180}
                                                alt='171x180'
                                                src={RepairIcon}
                                            />
                                            <Figure.Caption className='text-center caption-txt'>
                                                {t[currentLang].repair}
                                            </Figure.Caption>
                                        </Figure>
                                    </OverlayTrigger>
                                </Col>
                            </>
                        )}
                    </Row>

                    <Row className={'justify-content-center  m-0  mb-5'}>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck'
                                onClick={() => handleNext(0)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        {/* <Col xs={4} sm={4} lg={3}>
                            <Button
                                className='btn-nxt  m-0  justify-content-end'
                                onClick={() => handleNext(2)}
                            >
                                {t[currentLang].next}
                            </Button>
                        </Col> */}
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepTwo}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepThree(false)}
                // onExited={() => setShowButton(true)}
            >
                <>
                    <Row
                        className={
                            'p-4 justify-content-center main-container-form'
                        }
                    >
                        <Col>
                            <Questionaire
                                className='margin20-width60'
				query={query}
                                msgText={infoText}
                                placeholderTxt={placeholderTxt}
                                onChangeQuery={(text) => handleQuery(text)}
                            />
                        </Col>
                    </Row>
                    <Row className={'justify-content-end m-0 mb-5'}>
                        <Col xs={1} sm={1} lg={1}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck justify-content-end'
                                onClick={() => handleNext(1)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        <Col xs={2} sm={2} lg={6}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            {query === '' || query === null ? (
                                <OverlayTrigger
                                    trigger='click'
                                    trigger='focus'
                                    placement='top'
                                    overlay={popoverError}
                                >
                                    <Button className='btn-nxt justify-content-end'>
                                        {t[currentLang].next}
                                    </Button>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className='btn-nxt  m-0  justify-content-end'
                                    onClick={() => handleNext(3)}
                                >
                                    {t[currentLang].next}
                                </Button>
                            )}
                        </Col>
                        <Col xs={1} sm={1} lg={1}></Col>
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepThree}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepFour(false)}
            >
                <>
                    <Row
                        className={
                            'p-4 justify-content-center main-container-form'
                        }
                    >
                        <Col xs={6} lg={3}>
                            <Postal
                                lang={currentLang}
                                onPostalSelect={(code) => setPostalCode(code)}
				onAddressChange={(addr) => setPostalAddress(addr)}
                            />
                        </Col>
                        <Col xs={6} lg={3}>
                            {/* <div className='d-flex flex-row'>
                                <Form.Control
                                    as='select'
                                    className='mr-3'
                                    custom
                                    onChange={handleCountry}
                                >
                                    <option value='us'>US</option>
                                    <option value='de'>Germany</option>
                                    <option value='it'>Italy</option>
                                </Form.Control>
                                <Form.Control
                                    as='select'
                                    custom
                                    onChange={handleCity}
                                >
                                    {cities.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </Form.Control>
                            </div>
                             */}
                            <FormControl
                                type={'number'}
                                defaultValue={postalCode}
                                placeholder={
                                    t[currentLang].postalCodePlaceholder
                                }
                                aria-label='title'
                                className='input-field mt-4'
                                onChange={(event) =>
                                    setPostalCode(event.target.value)
                                }
                            />
                            {/* <div className='d-flex justify-content-end m-1 mb-3'>
                                <OverlayTrigger
                                    trigger='hover'
                                    placement='right'
                                    overlay={popoverPostalCodeInfo}
                                >
                                    <img
                                        src={InfoIcon}
                                        width='20'
                                        height='20'
                                    />
                                </OverlayTrigger>
                            </div> */}
                        </Col>
                    </Row>
                    <Row className={'justify-content-end m-0 mb-5'}>
                        <Col xs={1} sm={1} lg={1}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck justify-content-end'
                                onClick={() => handleNext(2)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        <Col xs={2} sm={2} lg={6}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            {postalCode === '' || postalCode === null ? (
                                <OverlayTrigger
                                    trigger='click'
                                    placement='top'
                                    overlay={popoverError}
                                >
                                    <Button className='btn-nxt justify-content-end'>
                                        {t[currentLang].next}
                                    </Button>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className='btn-nxt justify-content-end'
                                    onClick={() => handleNext(4)}
                                >
                                    {t[currentLang].next}
                                </Button>
                            )}
                        </Col>
                        <Col xs={1} sm={1} lg={1}></Col>
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepFour}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepFive(false)}
            >
                <>
                    <Row
                        className={
                            'p-4 justify-content-center main-container-form'
                        }
                    >
                        <Col xs={12} lg={8}>
                            {timelyRadio.map((item,index) => (
                                <div key={index}>
                                    <input
                                        type='radio'
                                        id={item.name}
                                        name={'duration'}
                                        value={item.value}
                                        onClick={() =>
                                            setSelectDuration(item.value)
                                        }
                                        
                                        defaultChecked={
                                            selectDuration === item.value &&
                                            'checked'
                                        }
                                    />
                                    <label
                                        htmlFor={item.name}
                                        style={{
                                            fontSize: 20,
                                            paddingLeft: 10,
                                        }}
                                    >
                                        {item.name}
                                    </label>
                                    {item.value === 'datePicker' && (
                                        <input
                                            type={'date'}
                                            className='input-field'
                                            style={{
                                                width: 180,
                                                marginLeft: 5,
                                            }}
                                            value={selectDate}
                                            onChange={(e) =>
                                                setSelectedDate(e.target.value)
                                            }
                                        />
                                    )}

                                    <br />
                                </div>
                            ))}
                        </Col>
                    </Row>
                    <Row className={'justify-content-end m-0 mb-5'}>
                        <Col xs={1} sm={1} lg={1}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck justify-content-end'
                                onClick={() => handleNext(3)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        <Col xs={2} sm={2} lg={6}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            {selectDuration === 'datePicker' &&
                            (selectDate === '' || selectDate === null) ? (
                                <OverlayTrigger
                                    trigger='click'
                                    placement='top'
                                    overlay={popoverDateError}
                                >
                                    <Button className='btn-nxt justify-content-end'>
                                        {t[currentLang].next}
                                    </Button>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className='btn-nxt  justify-content-end'
                                    onClick={() => handleNext(5)}
                                >
                                    {t[currentLang].next}
                                </Button>
                            )}
                        </Col>
                        <Col xs={1} sm={1} lg={1}></Col>
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepFive}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepSix(false)}
            >
                <>
                    <Row
                        className={
                            'p-4 justify-content-center main-container-form'
                        }
                    >
                        <Col xs={12} lg={10}>
                            <FormControl
                                defaultValue={requestTitle}
                                placeholder={t[currentLang].smartHomeTitle}
                                aria-label='title'
                                className='input-field margin20-width60'
                                onChange={(event) =>
                                    setRequestTitle(event.target.value)
                                }
                            />
                            {/* <div className='d-flex justify-content-end m-1 mb-3'>
                                <OverlayTrigger
                                    trigger='hover'
                                    placement='left'
                                    overlay={popoverTitleinfo}
                                >
                                    <img
                                        src={InfoIcon}
                                        width='20'
                                        height='20'
                                    />
                                </OverlayTrigger>
                            </div> */}
                        </Col>
                    </Row>
                    <Row className={'justify-content-end m-0 mb-5'}>
                        <Col xs={1} sm={1} lg={1}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck justify-content-end'
                                onClick={() => handleNext(4)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        <Col xs={2} sm={2} lg={6}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            {requestTitle === '' || requestTitle === null ? (
                                <OverlayTrigger
                                    trigger='click'
                                    placement='top'
                                    overlay={popoverError}
                                >
                                    <Button className='btn-nxt justify-content-end'>
                                        {t[currentLang].next}
                                    </Button>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className='btn-nxt  justify-content-end'
                                    onClick={() => handleNext(6)}
                                >
                                    {t[currentLang].next}
                                </Button>
                            )}
                        </Col>
                        <Col xs={1} sm={1} lg={1}></Col>
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepSix}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
                onEnter={() => setShowStepSeven(false)}
            >
                <>
                    <Row
                        className={
                            'pl-lg-5 pr-lg-5 pl-3 pr-3 justify-content-center main-container-form-email'
                        }
                    >
                        <Col xs={12} lg={10}>
                            <h5 className='caption-txt-email'>
                                {t[currentLang].emailDescTxt}
                            </h5>
                            <hr />
                            <FormControl
				autoComplete="off"
                                defaultValue={emailAddress}
                                placeholder={
                                    t[currentLang].emailInputPlaceholder
                                }
                                aria-label='email'
                                className='input-field mb-4'
                                onChange={(text) => handleEmailAddress(text)}
                            />
                            <FormControl
				autoComplete="off"
                                defaultValue=''
                                placeholder={
                                    t[currentLang].emailInputPlaceholder1
                                }
                                aria-label='confirm-email'
                                className='input-field mb-4'
                                onChange={(text) => handleConfirmEmail(text)}
                            />
                            <FormControl
                                defaultValue=''
                                placeholder={
                                    t[currentLang].nameInputPlaceholder
                                }
                                aria-label='full-name'
                                className='input-field mb-4'
                                onChange={(event) =>
                                    setFullName(event.target.value)
                                }
                            />
                            <Row>
                                <input
                                    type='checkbox'
                                    id='accepttc'
                                    name='accepttc'
                                    value='Accept'
                                    className='mt-1 text-right'
                                    onChange={() => setCheckTerms(!checkTerms)}
                                />
                                <p className='col-11 col-lg-6'>
                                    {/* https://www.my-gekko.com/de/copyright-footer-links/datenschutzerkl%C3%A4rung/142-0.html */}
                                    {t[currentLang].emailCheckBxBeforeHref}
                                    <a
                                        style={{
                                            color: 'blue',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            setModalShow(true);
                                        }}
                                    >
                                        {t[currentLang].emailCheckBxHref}
                                    </a>
                                    {t[currentLang].emailCheckBxAfterHref}
                                </p>

                                {!checkTerms && recaptcha && (
                                    <ReCAPTCHA
                                        sitekey='6LesJ6EaAAAAAMXmbAuR7TYEdy64gTt-FY60V9vE'
                                        onChange={onReCaptchaChange}
                                        className='col-12 col-lg-4 pl-5 mb-5'
                                    />
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <Row className={'justify-content-end m-0 mb-5'}>
                        <Col xs={1} sm={1} lg={1}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt btn-bck justify-content-end'
                                onClick={() => handleNext(5)}
                            >
                                {t[currentLang].back}
                            </Button>
                        </Col>
                        <Col xs={2} sm={2} lg={6}></Col>
                        <Col xs={4} sm={4} lg={2}>
                            {emailAddress === '' ||
                            emailAddress === null ||
                            !isValidEmail ||
                            !isConfirmEmail ||
                            fullName === '' ||
                            fullName === null ? (
                                <OverlayTrigger
                                    trigger='click'
                                    placement='top'
                                    overlay={
                                        !isValidEmail
                                            ? popoverInValidEmail
                                            : !isConfirmEmail
                                            ? popoverNotConfirmEmail
                                            : popoverFullNameErr
                                    }
                                >
                                    <Button className='btn-nxt justify-content-end'>
                                        {t[currentLang].submit}
                                    </Button>
                                </OverlayTrigger>
                            ) : checkTerms === false ? (
                                <OverlayTrigger
                                    trigger='click'
                                    placement='top'
                                    overlay={popoverAcceptTerms}
                                >
                                    <Button
                                        className='btn-nxt justify-content-end'
                                        onClick={() =>
                                            showRecaptcha(!recaptcha)
                                        }
                                    >
                                        {t[currentLang].submit}
                                    </Button>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className='btn-nxt justify-content-end'
                                    onClick={() => handleNext(7)}
                                >
                                    {t[currentLang].submit}
                                </Button>
                            )}
                        </Col>
                        <Col xs={1} sm={1} lg={1}></Col>
                    </Row>
                </>
            </CSSTransition>
            <CSSTransition
                in={showStepSeven}
                timeout={300}
                classNames='txt-input'
                unmountOnExit
            >
                <>
                    <Row
                        className={
                            'justify-content-center  main-container-form-final'
                        }
                    >
                        <Col xs={12} lg={10}>
                            {t[currentLang].emailHeadingTxt}
                            <hr />
                        </Col>

                        <Col xs={12} lg={8}>
                            <h4>
                                {t[currentLang].emailSentTxt} {emailAddress}
                                {t[currentLang].emailSentTxtLastGerman &&
                                    ' ' + t[currentLang].emailSentTxtLastGerman}
                                .
                            </h4>
                            <h5 className='notice-txt'>
                                <img
                                    src={ArrowRight}
                                    width='30'
                                    height='30'
                                    style={{ marginTop: -2 }}
                                />{' '}
                                {t[currentLang].confirmLinkTxt}
                            </h5>
                            <h5 className='cust-heading-txt'>
                                {t[currentLang].noEmailReceivedTxt}
                            </h5>
                            <br />
                            <h5 className='cust-heading-txt'>
                                {t[currentLang].checkSpamTxt}
                            </h5>
                        </Col>
                    </Row>
                    <Row className='justify-content-center align-items-center m-0 mb-4'>
                        <Col xs={4} sm={4} lg={5} className='text-right'>
                            {t[currentLang].resendEmailTxt}
                        </Col>
                        <Col xs={4} sm={4} lg={2}>
                            <Button
                                className='btn-nxt justify-content-start'
                                onClick={handleReSend}
                            >
                                {t[currentLang].resendEmailBtn}
                            </Button>
                        </Col>
                    </Row>
                </>
            </CSSTransition>
            {(showStepZero || showStepOne) && <Footer tip={tipTxt} />}
            <Modal
                size='lg'
                show={modalShow}
                onHide={() => {
                    setModalShow(false);
                }}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title id="contained-modal-title-vcenter">
          Modal heading
        </Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        className='w-100'
                        style={{ height: '90vh' }}
                        src={"https://www.my-gekko.com/" + currentLang + "/copyright-footer-links/datenschutzerkl%C3%A4rung/142-0.html"}
                        title='description'
                    />
                </Modal.Body>
                {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
            </Modal>
        </>
    );
};

export default Home;
